import catchWrapper from 'common/utils/catchWrapper'
import compact from 'common/utils/compact'

import { transactionId } from './giddyUpAttribution'

const SCRIPT_ID = 'giddy-up-everflow-sdk'
const SDK_LOAD_TIMEOUT = 5000

let sdkPromise

const withGuard = async (productId, cb) => {
  const account = getAccount(productId)
  if (!account) return

  await sdkPromise

  if (!window.EF) return

  return catchWrapper(() => cb(account))
}

const getAccount = (productId) => {
  const normalizedId = Number(productId)

  return (window.app?.giddyUpAccounts || []).find(({ productIds }) => productIds?.includes(normalizedId))
}

const loadSdk = () => {
  if (typeof window === 'undefined') return Promise.resolve(null)
  if (window.EF) return Promise.resolve(window.EF)
  if (sdkPromise) return sdkPromise

  sdkPromise = new Promise((resolve) => {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = 'https://www.gu-ecom.com/scripts/sdk/everflow.js'
    script.async = true
    script.onload = () => resolve(window.EF)
    script.onerror = () => resolve(null)
    setTimeout(() => resolve(null), SDK_LOAD_TIMEOUT)
    document.head.appendChild(script)
  })

  return sdkPromise
}

export const giddyUpInit = (productId) => {
  if (!getAccount(productId)) return

  return loadSdk()
}

export const giddyUpPageLoad = ({ productId }) =>
  withGuard(productId, (account) =>
    window.EF.conversion(
      compact({
        adv_event_id: account.events.pageLoad,
        transaction_id: transactionId(account.offerId),
        offer_id: account.offerId,
      }),
    ),
  )

export const giddyUpInitiateCheckout = ({ productId }) =>
  withGuard(productId, (account) =>
    window.EF.conversion(
      compact({
        adv_event_id: account.events.initiateCheckout,
        transaction_id: transactionId(account.offerId),
        offer_id: account.offerId,
      }),
    ),
  )

export const giddyUpPurchase = ({ orderId, total, productId }) =>
  withGuard(productId, (account) =>
    window.EF.conversion(
      compact({
        event_id: '0',
        transaction_id: transactionId(account.offerId),
        offer_id: account.offerId,
        amount: total,
        adv1: orderId,
      }),
    ),
  )
